<template>
  <div class="container-fluid travellers">
    <div v-if="isLoading" class= "loader-section">
      <frontoffice-loader/>
    </div>

    <div v-else>
      <div class="fixed-top sticky-header">
        <b-col cols="12" class="filters-title">
          <page-title>
            <div class="row justify-content-between">
              <div class="col-6 col-lg-8">{{ $t('traveller.list_title') }}</div>
              <div class="col-6 col-lg-4 travellers-action-btns">
                <travellers-import @travellerImported="onTravellerImported" v-if="isManager"/>
                <traveller-add :text="$t('_traveller_add')" @input="addTraveller"/>
              </div>
            </div>
          </page-title>
        </b-col>

        <b-container>
          <b-form class="form-inline row justify-content-center"
                  @submit.prevent="listTravellers"
          >
            <div class="col-12 col-md-6 col-xl-6">
              <text-input id="inlineFormInputName" name="filter-text"
                          label="traveller.per_text" :required="false"
                          v-model="filter"
              />
            </div>

            <div class="col-12 col-md-4 col-xl-4 text-center text-md-right text-lg-center filters-buttons"
            >
              <input type="button" class="btn orange-white" :value="$t('_validate')"
                     name="filter" @click="listTravellers"
              />

              <input type="button" class="btn orange-white" :value="$t('_reset')"
                     name="reset" @click="resetFilter"
              />
            </div>
          </b-form>
        </b-container>
      </div>

      <div class="col-12 alertBox">
        <b-alert v-if="alert.show" :variant="alert.variant" class="col-12" show dismissible>
          <div v-if="alert.msg" v-html="alert.msg" />

          <div v-for="msg in alert.data">
            {{ msg }}
          </div>
        </b-alert>
      </div>

      <mq-layout :mq="['xs', 'sm', 'md','lg']">
        <b-table striped hover
                 :items="itemsMvp"
                 :fields="fieldsMvp"
                 :busy="isLoading"
                 :per-page="perPage"
                 id="table2"
                 :show-empty="true"
                 :empty-text="$t('_no_result_found')"
                 @sort-changed="onSort"
        >
          <template slot="show_details" slot-scope="row">
            <button @click="row.toggleDetails" class="toggle">
              <i v-if="row.detailsShowing" class="fas fa-minus"></i>
              <i  v-else class="fas fa-plus"></i>
            </button>
          </template>

          <template slot="row-details" slot-scope="row">
            <div  class="detailCell-wrapper">
              <p class="label">{{$t('_mobile_phone')}} : </p>
              <p>{{row.item.mobile_phone}}</p>
            </div>

            <div class="detailCell-wrapper">
              <p class="label">{{$t('_email')}} : </p>
              <p><a :href="'mailto:' + row.item.email">{{ row.item.email }}</a></p>
            </div>

            <div class="btn-wrapper"
                 v-if="displayActions && (row.item.canUserEdit || row.item.canUserDisable)"
            >
              <p class="label">{{$t('_actions')}} : </p>

              <traveller-edit v-if="row.item.canUserEdit"
                              :traveller="row.item"
                              :company-input-fields="companyInputFields"
                              @input="editTraveller"
              />

              <list-btn v-if="row.item.canUserDisable"
                        :default-state="row.item.enabled ? 'enable' : 'disable'"
                        :callback="onSwapDisable"
                        :id="row.item.id"
                        :class="row.item.enabled ? 'btn-enable' : 'btn-disable'"
              />
            </div>
          </template>
        </b-table>

        <b-pagination v-model="currentPage" :total-rows="nbTravellers"
                      :per-page="perPage" aria-controls="table2" size="md"
                      @input="listTravellers"
        />
      </mq-layout>

      <mq-layout :mq="['xl', 'xxl']">
        <b-table striped hover
                 :items="itemsDvp"
                 :fields="fieldsDvp"
                 :busy="isLoading"
                 :per-page="perPage"
                 id="table1"
                 :show-empty="true"
                 :empty-text="$t('_no_result_found')"
                 @sort-changed="onSort"
        >
          <template slot="email" slot-scope="data">
            <a :href="'mailto:' + data.value">{{ data.value }}</a>
          </template>

          <template slot="btns" slot-scope="data">
            <traveller-edit v-if="data.item.canUserEdit"
                            :traveller="data.item"
                            :company-input-fields="companyInputFields"
                            @input="editTraveller"
            />

            <list-btn v-if="data.item.canUserDisable"
                      :default-state="data.item.enabled ? 'enable' : 'disable'"
                      :callback="onSwapDisable"
                      :id="data.item.id"
                      :class="data.item.enabled ? 'btn-enable' :'btn-disable'"
            />
          </template>
        </b-table>

        <b-pagination v-model="currentPage"
                      size="md"
                      :total-rows="nbTravellers"
                      :per-page="perPage"
                      aria-controls="table1"
                      @input="listTravellers"
        />

	      <p v-if="nbTravellers" class="mt-3">
          {{ nbTravellers }} {{ $tc('booking.summary.traveller_s', nbTravellers) }}
        </p>
      </mq-layout>
    </div>
  </div>
</template>

<script>
import pageTitle from '@/components/frontoffice/pageTitle'
import frontofficeLoader from '@/components/frontoffice/loader'
import { getFrontOfficeHelperStyle } from '@/utils/style'
import CommonApi from '@/api/commonApi'
import submitButton from '@/components/frontoffice/form/baseInput/submit'
import travellerAdd from '@/components/frontoffice/form/traveller/add'
import travellersImport from '@/components/frontoffice/form/traveller/import'
import listBtn from '@/components/frontoffice/button/list'
import travellerEdit from '@/components/frontoffice/form/traveller/edit'
import formatter from '@/components/global/mixins/formatterMethods'
import radioInput from '@/components/frontoffice/form/baseInput/radio'
import selectInput from '@/components/frontoffice/form/baseInput/select'
import textInput from '@/components/frontoffice/form/baseInput/text'

export default {
  components: {
    pageTitle,
    frontofficeLoader,
    submitButton,
    travellerAdd,
    travellersImport,
    travellerEdit,
    listBtn,
    radioInput,
    selectInput,
    textInput
  },

  mixins: [formatter],

  data () {
    return {
      alert: {},
      hotelBackground: false,
      isLoading: false,
      itemsMvp: [{ _showDetails: true }],
      fieldsMvp: [
        'show_details',
        { key: 'gender', sortable: true, label: this.$t('_gender_short') },
        { key: 'first_name', sortable: true, label: this.$t('_first_name') },
        { key: 'last_name', sortable: true, label: this.$t('_last_name') }
      ],
      itemsDvp: [],
      fieldsDvp: [
        { key: 'gender', sortable: false, label: this.$t('_gender_short') },
        { key: 'first_name', sortable: true, label: this.$t('_first_name') },
        { key: 'last_name', sortable: true, label: this.$t('_last_name') },
        { key: 'mobile_phone', sortable: false, label: this.$t('_phone') },
        { key: 'email', sortable: true, label: this.$t('_email') },
        { key: 'formattedEnabled', sortable: true, label: this.$t('_enabled') },
        { key: 'btns', sortable: false, label: this.$t('_actions') }
      ],
      commonApi: new CommonApi(),
      companyInputFields: null,
      filter: '',
      filterEnable: {
        value: 'all', text: this.$t('traveller.all')
      },
      isManager: false,
      displayActions: true,
      perPage: 10,
      currentPage: 1,
      nbTravellers: null,
      orderBy: '',
      order: ''
    }
  },

  methods: {
    listTravellers () {
      this.isLoading = true
      this.commonApi.listTravellersAll(this.filter, this.filterEnable, this.perPage, this.currentPage, this.orderBy, this.order).then(response => {
        this.nbTravellers = parseInt(response.data.data['nbTravellers'])
        if (this.nbTravellers <= 0) {
          this.isLoading = false
        }
        let actions = response.data.data['travellersActions']
        let displayActions = false

        for (let i in actions) {
          if (actions.hasOwnProperty(i)) {
            if (actions[i].length) {
              // If no action available, do not display actions column
              displayActions = true
            }
          }
        }

        if (!displayActions) {
          // for small screens
          this.displayActions = false
          // for larger screens
          this.fieldsDvp = this.fieldsDvp.filter(item => {
            return item.key !== 'btns'
          })
        } else {
          // Nous avons des cas où des voyageurs sont à modifier sur la deuxième page du tableau
          this.displayActions = true // Nous devons remettre l'affichage des boutons à vrai
          this.fieldsDvp = this.fieldsDvp.filter(item => {
            return item.key !== 'btns'
          }) // Si la colonne est déjà présente on la retire

          this.fieldsDvp.push({ key: 'btns', sortable: false, label: this.$t('_actions') }) // Ajouter la colonne bouton
        }

        let tempItems = response.data.data['travellers']

        for (let item of tempItems) {
          item.gender = this.formatGender(item.gender)
          item.first_name = this.formatToUCFirst(item.first_name)
          item.last_name = item.last_name.toUpperCase()
          item.mobile_phone = this.formatPhoneNumber(item.mobile_phone)
          item.formattedEnabled = this.$i18n.t(this.formatBool(item.enabled, false))
          item.canUserEdit = actions['edit'].indexOf(item.id) !== -1
          item.canUserDisable = actions['disable'].indexOf(item.id) !== -1
        }

        this.itemsDvp = tempItems
        this.itemsMvp = tempItems
        this.isLoading = false
      })
    },

    addTraveller () {
      this.listTravellers()
    },

    editTraveller () {
      this.listTravellers()
    },

    onTravellerImported (data) {
      this.listTravellers()
      this.alert = data
    },

    onSwapDisable (travellerId, state) {
      this.commonApi.swapTravellerEnabled(travellerId)
        .then(response => {
          if (response['data']['success']) {
            this.listTravellers()
          }
        })
    },

    resetFilter () {
      this.filter = ''
      /* this.filterEnable = {
        value: 'all', text: this.$t('traveller.all')
      } */
      this.listTravellers()
    },

    onSort (options) {
      this.orderBy = options.sortBy
      this.order = options.sortDesc ? 'DESC' : 'ASC'

      this.listTravellers()
    }
  },

  computed: {
    wrapperClass () {
      return this.hotelBackground ? 'hotel-background' : ''
    },

    contentClass () {
      return this.hotelBackground ? 'has-background' : ''
    },

    backgroundImageStyle () {
      return getFrontOfficeHelperStyle(this.hotelBackground)
    },

    formClass () {
      return this.displayGrid ? 'grid' : ''
    }

    /* getEnableFilterOptions () {
      return [
        { value: 'enabled', text: this.$t('traveller.enabled_travellers'), selected: false },
        { value: 'disabled', text: this.$t('traveller.disabled_travellers'), selected: false },
        { value: 'all', text: this.$t('traveller.all'), selected: true }
      ]
    } */
  },

  created () {
    if (window.innerWidth < 1024) {
      this.mobile = true
    }
    this.isManager = this.$store.getters['security/hasRole']('ROLE_MANAGER')
    this.companyInputFields = this.$store.getters['security/company'].inputFields
    this.listTravellers()
  }
}
</script>

<style lang="scss">
  @import '@/assets/sass/frontoffice/modal.scss';
</style>
